class declareStockRootCtrl {
    constructor($rootScope, $scope, httpRequest) {
        // 用户信息
        const { userInfo } = $rootScope
        // 存储页面信息
        $scope.pageState = {
            idToken: $rootScope.idToken,
            userInfo,
        }

        // 字典数据
        $scope.dictData = {}
        const typecodeArrStr = '["ivat_inv_type","scan_type","tax_disk_type","stock_inv_type"]'
        const typecodeArr = ['ivat_inv_type', 'scan_type', 'tax_disk_type', 'stock_inv_type']
        httpRequest.get_dictByTypeArr(typecodeArrStr).then((res) => {
            $scope.dictData = $.extend($scope.dictData, res.data.value)
            for (let i = 0, l = typecodeArr.length; i < l; i++) {
                const arr = $scope.dictData[typecodeArr[i]]
                arr.push({ enumTypeCode: null, enumName: '全部', enumCode: '' })
                arr.reverse()
                $scope.dictData[typecodeArr[i]] = arr
            }

            console.log($scope.dictData)
        })
    }
}

declareStockRootCtrl.$inject = ['$rootScope', '$scope', 'httpRequest']
export default declareStockRootCtrl



// WEBPACK FOOTER //
// ./src/app/outputManage/stock/stocks/declareStockRootCtrl.js